<div class="overlay pl-5 pt-3 carousel-caption">
  <span class="overlay-column">
    <h5 class="text-uppercase">{{ iter?.name }}</h5>
  
    <h6 class="small itinerary-detail">
      {{ "ITINERARY.TRIP-LENGTH" | translate }}
      {{ iter?.duration }}
      <span *ngIf="iter?.duration == 1">
        {{ "ITINERARY.NIGHT" | translate }}
        <small>{{ "ITINERARY.NIGHTSNOTES" | translate }}</small>
      </span>
      <span *ngIf="iter?.duration != 1">
        {{ "ITINERARY.NIGHTS" | translate }}
        <small>{{ "ITINERARY.NIGHTSNOTES" | translate }}</small>
      </span>
    </h6>
  
    <h6 class="small itinerary-detail">
      {{ "ITINERARY.HOTEL.ROOMS" | translate }} {{ iter?.rooms.length }}
    </h6>
  
    <h6 class="small itinerary-detail">
      {{ "ITINERARY.PAX" | translate }}
      {{ getTotalAdult() }} {{ "ITINERARY.PAX-TYPE.ADT" | translate }} 
      <span *ngIf="hasChildren()">, {{ getTotalChildren() }}
        {{ "ITINERARY.PAX-TYPE.CHD" | translate }} </span><br>
        <ul class="mb-0 pl-3">
          <ng-container *ngFor="let passenger of iter?.passengers"> 
            <li>{{ passenger.title }} {{ passenger.name }} {{ passenger.surname }}</li> 
          </ng-container> 
        </ul>
    </h6>
  </span>

  <span class="overlay-column">
    <h6 class="small itinerary-detail --small d-none" *ngIf="lastUpdate">
      {{lastUpdate | localizedDate: 'dd MMMM yyyy'}}
    </h6>
    <h6 class="small itinerary-detail --small">
      <!-- {{ "ITINERARY.REFERENCE" | translate }} : -->
      <span class="overlay-state mt-3" *ngIf="stateKey as key">{{ key | translate }}</span> :
      <span class="iter-riferimento">{{ iter?.riferimento }} </span>
    </h6>
  </span>

</div> 